import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  // Load translation using http -> see /public/locales (copied from src/locales during build)
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    // Loading from /locales URL path (which maps to public/locales in the file system)
    backend: {
      loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json`,
    },
    fallbackLng: 'en-US',
    lng: localStorage.getItem('i18nextLng') ?? 'en-US',
    debug: false, // process.env.NODE_ENV === 'development',

    // Common namespaces for all components
    defaultNS: 'translation',
    ns: ['translation', 'features'],

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    react: {
      useSuspense: true,
    },
  })

export default i18n
